// extracted by mini-css-extract-plugin
export default {"containerBtnCompartir":"BtnCompartir_containerBtnCompartir__Nsn-D","btnCompartir":"BtnCompartir_btnCompartir__cQDFM"};